<template>
  <div>
    <b-modal
      id="modal-prevent-closing-pay"
      ref="modal-pay"
      v-model="showModal"
      hide-footer
      centered
      size="lg"
    >
      <template #modal-title> Share your link </template>
      <div class="flex-wrap d-flex">
        <div
          v-for="network in networks"
          :key="network.network"
          class="col-3 p-75"
        >
          <ShareNetwork
            class="btn rounded-lg text-white w-100"
            :network="network.network"
            :style="{ backgroundColor: network.color }"
            :url="openShare"
            :title="sharing.title"
            :description="sharing.description"
            :quote="sharing.quote"
            :hashtags="sharing.hashtags"
            :twitterUser="sharing.twitterUser"
          >
            <span>{{ network.name }}</span>
          </ShareNetwork>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BButtonGroup, BButton, BModal } from "bootstrap-vue";

export default {
  components: {
    BButtonGroup,
    BButton,
    BModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sharing: {
        url: "",
        title: "",
        description: "",
        quote: "",
        hashtags: "",
        twitterUser: "",
      },
      networks: [
        {
          network: "facebook",
          name: "Facebook",
          icon: "fab fah fa-lg fa-facebook-f",
          color: "#1877f2",
        },
        {
          network: "instagram",
          name: "Instagram",
          icon: "fab fah fa-lg fa-instagram",
          color: "#e9152d",
        },
     
        {
          network: "linkedin",
          name: "LinkedIn",
          icon: "fab fah fa-lg fa-linkedin",
          color: "#007bb5",
        },
        {
          network: "telegram",
          name: "Telegram",
          icon: "fab fah fa-lg fa-telegram-plane",
          color: "#0088cc",
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: "fab fah fa-lg fa-whatsapp",
          color: "#25d366",
        },
      ],
    };
  },
  computed: {
     showModal: {
      set(newVal) {
        this.$emit("input", newVal);
      },
      get() {
        return this.visible;
      },
    },
    openShare() {
      return window && window.location ? window.location.href : "";
    },
  },
};
</script>
<style></style>
